import React from 'react';
import { getRecentlyViewedProduct } from '@core_modules/theme/services/graphql';
import ContainerScroll from '@common/ContainerScroll';
import ProductListSkeleton from '@plugin_productlist/components/ProductListSkeleton';
import cx from 'classnames';
import { getLoginInfo } from '@helper_auth';
import { getCookiesSingle } from '@helper_cookies';
import { visitorIdCookie } from '@config';
import ProductSlider from '@core_modules/cms/components/cms-renderer/magezon/MagezonProduct/ProductSlider';

const RecentlyViewed = (props) => {
    const { storeConfig, t } = props;
    const [getProduct, { data, loading }] = getRecentlyViewedProduct();
    const isLogin = getLoginInfo();
    const [dataProduct, setDataProduct] = React.useState({});

    const visitor_id = getCookiesSingle(visitorIdCookie);
    const page_size = parseInt(storeConfig?.display_recently_viewed || '10', 10);

    const productProps = {
        className: cx('carousel-item !min-w-[138px] tablet:!min-w-[230px] desktop:!min-w-[288px] rounded-none',
            'shadow-none border-none desktop:hover:shadow-none flex-shrink-0 !basis-[160px] !tablet:basis-[230px]',
            '!desktop:basis-[288px] !h-[initial] desktop:!min-w-[calc(100%/4-0.75rem)] tablet:!min-w-[calc(100%/3-0.5rem)]',
            'mobile:!min-w-[calc(100%/2-0.2rem)]'),
        enableImage: true,
        enablePrice: true,
        enableProductCompare: true,
        enableProductName: true,
        enableQuickView: true,
        enableRating: true,
        enableWishlist: true,
        imageProps: {
            className: 'product-image !w-full !h-full',
            classContainer: 'product-image-container !w-full !h-full',
        },
        storeConfig,
    };

    React.useEffect(() => {
        if (visitor_id || isLogin) {
            getProduct({
                variables: {
                    ...visitor_id && { visitor_id: parseInt(visitor_id, 10) },
                    page_size,
                },
            });
        }
    }, [visitor_id, isLogin]);

    React.useEffect(() => {
        if (data?.recentViewedProducts?.items && !loading) {
            setDataProduct({ products: data?.recentViewedProducts });
        }
    }, [data, loading]);

    if (loading) {
        return (
            <>
                <ContainerScroll
                    showArrow={false}
                    className="px-[10px] desktop:!gap-[20px] tablet:!gap-3 mobile:!gap-2"
                    arrowSize={24}
                    arrowProps={{
                        className: cx(
                            'opacity-100',
                            '!px-0',
                        ),
                        leftNavClassName: cx(
                            'rounded-none',
                            'w-[44px]',
                            'h-[44px]',
                            'opacity-50',
                            'hover:opacity-100',
                        ),
                        rightNavClassName: cx(
                            'rounded-none',
                            'w-[44px]',
                            'h-[44px]',
                            'opacity-50',
                            'hover:opacity-100',
                        ),
                    }}
                    showDots
                >
                    <ProductListSkeleton
                        rootClassName={cx(
                            'skeleton desktop:!min-w-[calc(100%/4-0.75rem)] tablet:!min-w-[calc(100%/3-0.5rem)] ',
                            'mobile:!min-w-[calc(100%/2-0.2rem)] !p-0 ',
                        )}
                        length={5}
                        isGrid
                    />
                </ContainerScroll>
            </>
        );
    }

    return (
        <>
            {dataProduct?.products?.items?.length > 0 && !loading ? (
                <ProductSlider
                    title={t('common:recentlyViewed')}
                    className="desktop:!gap-[20px] tablet:!gap-3 mobile:!gap-2"
                    arrowSize={24}
                    productProps={productProps}
                    data={dataProduct}
                    showArrow
                />
            ) : null}
        </>
    );
};

export default RecentlyViewed;
